import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useRoleHttp } from '@/core/api/roles'
import { Role, RolePayload } from '@/core/models/role'

export type RoleCollection = {
    data: Array<Role>,
    meta?: MetaPayload,
    links?: any
}

const state: RoleCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const roleCollection: Module<RoleCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: RoleCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: RolePayload) => {
                state.data.push(new Role(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useRoleHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: RoleCollection): RoleCollection => {
            return state
        }
    }
}